import React, { useContext } from 'react';

import { Field, FieldArray } from 'formik'
import { TextField } from 'formik-material-ui';

import {
    Grid,
    Button,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider
} from '@material-ui/core';

import { 
    FieldError
} from '../../../../common';

import { AddressForm } from '../common/AddressForm';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { defaultBankReference } from '../../../../../content';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    title: {
        marginTop: '24px',
        padding: '12px'
    }
}));

export const BankReferencesForm = (props) => {
    const classes = useStyles();

    const { 
        state,
    } = useContext(CustomerRequestContext)

    const { 
        values,
        isSavingRequest
    } = useContext(TabsContext)

    return (
        <Card className={classes.card}>
            <CardHeader title="Bank/Trade references" />
            <CardContent>
                <Typography variant="body1">
                    Letter to client’s supplier or bank to ask reference
                </Typography>
                <FieldArray
                    name="bankReferences"
                    render={arrayHelpers => {
                        return (
                            <>
                                {values.bankReferences && values.bankReferences.length > 0 &&
                                    values.bankReferences.map((reference, index) => {
                                        return (
                                            
                                            <Grid key={index} container spacing={3} justifyContent="center">
                                                <Grid container>
                                                    <Grid item xl={12} md={12} xs={12}>
                                                        <Typography variant="body1" className={classes.title}>
                                                            {`Reference No. ${index + 1}`}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xl={6} md={12} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        type="text"
                                                        name={`bankReferences[${index}].name`}
                                                        label="Name"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`bankReferences[${index}].name`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={6} md={12} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        type="text"
                                                        name={`bankReferences[${index}].account`}
                                                        label="Account"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`bankReferences[${index}].account`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={12} md={12} xs={12}>
                                                    <AddressForm                                                         
                                                        formSuffixName={`bankReferences[${index}].address`} 
                                                        suffixIndex={index} 
                                                        disabled={props.disabled}/>
                                                </Grid>
                                                <Grid item xl={12} md={12} xs={12}>
                                                    <Typography variant="subtitle1">
                                                        Contact
                                                    </Typography>
                                                </Grid>
                                                <Grid item xl={4} md={4} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        type="email"
                                                        name={`bankReferences[${index}].email`}
                                                        label="Email"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`bankReferences[${index}].email`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={4} md={4} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        type="text"
                                                        name={`bankReferences[${index}].phone`}
                                                        label="Phone"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`bankReferences[${index}].phone`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={4} md={4} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        type="text"
                                                        name={`bankReferences[${index}].fax`}
                                                        label="FAX"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`bankReferences[${index}].fax`} errors={state.errors} />
                                                </Grid>
                                                <Divider style={{ width: "100%" }} />
                                                <Grid item xl={12}>
                                                    {index === 0 
                                                        && values.bankReferences.length === 1 
                                                        && !props.disabled && (
                                                        <Button
                                                            style={{float:"right", marginTop:10}}
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={isSavingRequest || props.disabled}
                                                            onClick={() => arrayHelpers.push({ ...defaultBankReference })}>
                                                            Add reference
                                                        </Button>
                                                    )}
                                                    {index === 1 
                                                        && values.bankReferences.length === 2 
                                                        && !props.disabled && (
                                                        <Button
                                                            style={{ float: "right", marginTop: 10 }}
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={isSavingRequest || props.disabled}
                                                            onClick={() => arrayHelpers.pop()}>
                                                            Remove reference
                                                        </Button>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            
                                        );
                                    })}
                            </>
                            );
                    }}
                />
            </CardContent>
        </Card>
    );
}